// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K20KJKj55bAO_ZnZgWN4{align-items:center;height:32px;display:flex}.Ib8c_WZSDEB0aNaaWhdM,.YSmbAVF7AXgZvoPOdw4R{color:var(--content-primary-primary);margin-left:8px;font-size:13px;font-weight:400;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countLabelWrapper": `K20KJKj55bAO_ZnZgWN4`,
	"label": `Ib8c_WZSDEB0aNaaWhdM`,
	"countLabel": `YSmbAVF7AXgZvoPOdw4R`
};
export default ___CSS_LOADER_EXPORT___;
